// eslint-disable-next-line import/prefer-default-export
function getLayerName(sourceKey, layerKey, managed) {
  if (!managed) {
    return layerKey;
  }
  return `${sourceKey}›${layerKey}`;
}

export { getLayerName };
//# sourceMappingURL=utils.js.map
